// AG-Grid Header Components for Table Editor

export class ColumnHeaderForTarget {
  private params: any;
  private eGui!: HTMLElement;
  
  constructor() {}
  
  init(params: any) {
    this.params = params;
    this.eGui = document.createElement('div');
    this.eGui.className = 'target-header-cell';
    
    // Create main container
    const container = document.createElement('div');
    container.className = 'flex flex-col h-full';
    
    // Create column name
    const columnName = document.createElement('div');
    columnName.className = 'ag-header-cell-text';
    columnName.textContent = params.displayName;
    container.appendChild(columnName);
    
    // Create key (sub-label) - conditionally shown based on showColumnKeys
    const showColumnKeys = params.showColumnKeys !== false; // Default to true if not specified
    if (showColumnKeys) {
      const keySpan = document.createElement('div');
      keySpan.className = 'ag-subheader-cell-text';
      keySpan.textContent = `${params.key || '-'}`;
      container.appendChild(keySpan);
    }
    
    this.eGui.appendChild(container);
  }
  
  getGui() {
    return this.eGui;
  }
  
  destroy() {
    // Cleanup if needed
  }
}

export class ColumnHeaderForSource {
  private params: any;
  private eGui!: HTMLElement;
  
  constructor() {}
  
  init(params: any) {
    this.params = params;
    this.eGui = document.createElement('div');
    this.eGui.className = 'source-header-cell';
    
    // Create main container
    const container = document.createElement('div');
    container.className = 'flex flex-col h-full';
    
    // Create column name
    const columnName = document.createElement('div');
    columnName.className = 'ag-header-cell-text';
    columnName.textContent = params.displayName;
    
    // Create key (sub-label)
    const keySpan = document.createElement('div');
    keySpan.className = 'ag-subheader-cell-text';
    keySpan.textContent = `${params.key || '-'}`;
    
    
    // Create button container
    const buttonContainer = document.createElement('div');
    buttonContainer.className = 'flex gap-1 items-center mt-1';
    
    // Create edit button (pencil icon) with Flowbite styling
    const editButton = document.createElement('button');
    editButton.className = 'general-button icon-only inline-flex items-center justify-center w-6 h-6 text-gray-500 hover:text-blue-600 hover:bg-blue-50 rounded-md border border-gray-200 hover:border-blue-300 transition-colors focus:ring-2 focus:ring-blue-500 focus:ring-offset-2';
    editButton.innerHTML = '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="pencil" class="svg-inline--fa fa-pencil " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1 0 32c0 8.8 7.2 16 16 16l32 0zM362.7 18.7L348.3 33.2 325.7 55.8 314.3 67.1l33.9 33.9 62.1 62.1 33.9 33.9 11.3-11.3 22.6-22.6 14.5-14.5c25-25 25-65.5 0-90.5L453.3 18.7c-25-25-65.5-25-90.5 0zm-47.4 168l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"></path></svg>';
    editButton.title = 'Edit column';
    editButton.addEventListener('click', (e) => {
      e.stopPropagation();
      this.handleEditColumn(params.columnIndex, e);
    });
    
    // Create delete button (trash icon) with Flowbite styling
    const deleteButton = document.createElement('button');
    deleteButton.className = 'general-button icon-only inline-flex items-center justify-center w-6 h-6 text-gray-500 hover:text-red-600 hover:bg-red-50 rounded-md border border-gray-200 hover:border-red-300 transition-colors focus:ring-2 focus:ring-red-500 focus:ring-offset-2';
    deleteButton.innerHTML ='<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="trash" class="svg-inline--fa fa-trash " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z"></path></svg>';
    deleteButton.title = 'Delete column';
    deleteButton.addEventListener('click', (e) => {
      e.stopPropagation();
      this.handleDeleteColumn(params.columnIndex);
    });
    
    // Create status icon (check or exclamation) - simple icon, not button
    const statusIcon = document.createElement('div');
    statusIcon.className = 'inline-flex items-center justify-center w-6 h-6';
    
    // Determine status based on mapping
    const isMapped = params.isMapped || false;
    if (isMapped) {
      statusIcon.innerHTML = '<svg class="w-5 h-5 match-icon" viewBox="0 0 640 640"><path fill="currentColor" d="M320 576C178.6 576 64 461.4 64 320C64 178.6 178.6 64 320 64C461.4 64 576 178.6 576 320C576 461.4 461.4 576 320 576zM438 209.7C427.3 201.9 412.3 204.3 404.5 215L285.1 379.2L233 327.1C223.6 317.7 208.4 317.7 199.1 327.1C189.8 336.5 189.7 351.7 199.1 361L271.1 433C276.1 438 282.9 440.5 289.9 440C296.9 439.5 303.3 435.9 307.4 430.2L443.3 243.2C451.1 232.5 448.7 217.5 438 209.7z"/></svg>';
      statusIcon.title = 'Column is mapped';
    } else {
      statusIcon.innerHTML = '<svg class="w-5 h-5 no-match-icon" viewBox="0 0 20 20"><path fill="currentColor" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path></svg>';
      statusIcon.title = 'Column is not mapped';
    }
    
    // Append elements
    buttonContainer.appendChild(editButton);
    buttonContainer.appendChild(deleteButton);
    buttonContainer.appendChild(statusIcon);
    
    container.appendChild(columnName);
    container.appendChild(keySpan);
    container.appendChild(buttonContainer);
    
    this.eGui.appendChild(container);
  }
  
  private handleEditColumn(columnIndex: number, event?: MouseEvent) {
    // Call the callback if provided, passing the event for positioning
    if (this.params.onEditColumn) {
      this.params.onEditColumn(columnIndex, event);
    }
  }
  
  private handleDeleteColumn(columnIndex: number) {
    // Call the callback if provided
    if (this.params.onDeleteColumn) {
      this.params.onDeleteColumn(columnIndex);
    }
  }
  
  getGui() {
    return this.eGui;
  }
  
  destroy() {
    // Cleanup if needed
  }
}
